import React, { useState, useEffect } from 'react'
import { FormGroup, FormControl, Form, Button } from "react-bootstrap";
import { editUser } from '../../../Services/users.service';


const UpdateUserForm = (props) => {
  const [data, setData] = useState({

    userName: "",
    email: "",
    status: "",
  })
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [status, setStatus] = useState(null)
  const [isSubmit, setIsSubmit] = useState(false)

  useEffect(() => {
    if (!!props.userData) {
      console.log("props", props);
      setName(props.userData.name)
      setEmail(props.userData.email)
      setStatus(props.userData.status)
    }
  }, []);

  let handleChange = (value) => {
    // setData({ ...data, [e.target.name]: e.target.value })
    console.log("setValue", value);
    if (value == "true") {
      setStatus(true)
      console.log("here for true, ", status);
    }
    else {
      setStatus(false)
      console.log("here for false, ", status);
    }

    console.log("status", status);


  }


  let handleSubmit = (event) => {
    event.preventDefault();
    const answer = window.confirm("are you sure?");
    if (answer) {
      setIsSubmit(true)

      let _data = {
        name: name,
        // email: email,
        status: status,
        userId: props.userData ? props.userData.userId : '',
      }

      console.log('before sending data', _data);

      editUser(_data).then((resp) => {
        setIsSubmit(false)
        props.setHandleClose()
      })
    }
  }


  return (
    <>
      <div className='d-flex align-items-center mb-5'>
        <div className='flex-1 container'>
          <div className="addBusinessDiv ">


            <form className='' onSubmit={handleSubmit}>



              <div className="form-group">
                <span className='bold-semifont paraListing'>User Name</span>
                <input className="form-control" placeholder="User Name" name="userName" type="text" onChange={(e) => setName(e.target.value)} value={name}></input>
              </div>
              <div className="form-group">
                <span className='bold-semifont paraListing'>Email </span>
                <input className="form-control" placeholder="Email" readOnly name="email" type="email" onChange={(e) => setEmail(e.target.value)} value={email}></input>
              </div>

              <div className="form-group">
                <span className='bold-semifont paraListing'>Status</span>
                <label className="db">
                  <input className="" name="status" type="radio" onChange={(event) => handleChange(event.target.value)} checked={status} value={true}></input>Active
                </label>
                <label className="db">
                  <input className="" name="status" type="radio" onChange={(event) => handleChange(event.target.value)} checked={!status} value={false} ></input>Block
                </label>
              </div>





              {/* social media */}
              {/* <span className='bold-semifont para mt-5 dib'>SOCIAL MEDIA</span>
            <div className='app-border-full'></div> */}

              {/* <hr /> */}

              <div className="form-group text-center mt-4">
                <Button className='round-button' type="submit">{isSubmit ? 'Please wait' : 'Save'}</Button>
              </div>

            </form>
          </div>
        </div>
      </div>

    </>
  )
}
export default UpdateUserForm